const he = {
    common: {
        history: "גרסה היסטורית"
    }
};
export default he;



// WEBPACK FOOTER //
// ./src/i18n/langs/he.js